import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import { Container } from './Container';
import { Text } from './Text';

export const isDarkTheme = (theme: { snackbar?: 'dark' }) =>
  theme.snackbar === 'dark';

export const snackbarTransitionDuration = 300;
export const snackbarRestDuration = 5000;

type SnackbarProps = {
  onExited?: () => void;
  theme?: { snackbar?: 'dark' };
};

export const Snackbar: React.FunctionComponent<SnackbarProps> = ({
  onExited,
  theme = {},
  ...props
}) => {
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    setShowSnackbar(true);
    const timer = setTimeout(
      () => setShowSnackbar(false),
      snackbarRestDuration,
    );
    return () => clearTimeout(timer);
  }, []);

  return (
    <CSSTransition
      in={showSnackbar}
      onExited={onExited}
      timeout={{ enter: 0, exit: snackbarTransitionDuration }}
      unmountOnExit
      mountOnEnter
    >
      {state => (
        <ThemeProvider theme={theme}>
          <Container role="status" state={state}>
            <Text {...props} />
          </Container>
        </ThemeProvider>
      )}
    </CSSTransition>
  );
};
